// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EmailVerificationScreen from './auth/EmailVerificationScreen';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, requiredRole = null, requireEmailVerification = true }) => {
  const { currentUser, userProfile, loading, refreshUserProfile } = useAuth();

  // Show loading screen while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="text-center">
          <Loader2 className="animate-spin text-emerald-500 mx-auto mb-4" size={48} />
          <p className="text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to auth if not signed in
  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  // Check email verification for email/password users
  if (requireEmailVerification && !currentUser.emailVerified) {
    // Google users are auto-verified, skip for them
    const isGoogleUser = currentUser.providerData.some(
      provider => provider.providerId === 'google.com'
    );
    
    if (!isGoogleUser) {
      return (
        <EmailVerificationScreen 
          onVerified={async () => {
            await refreshUserProfile();
            window.location.reload(); // Force refresh to update UI
          }} 
        />
      );
    }
  }

  // Check role requirement
  if (requiredRole && !userProfile?.roles?.includes(requiredRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;